<div class="error-container" *ngIf="currentError !== null">
  <article class="error __101" *ngIf="isTechnicalError()">
    <div class="__icon">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px"
           viewBox="0 0 98.5 93" style="enable-background:new 0 0 98.5 93;" xml:space="preserve">
    <style type="text/css">
        .st0 {
            fill: #39006B;
        }

        .st1 {
            fill: none;
            stroke: #39006B;
            stroke-width: 6;
            stroke-linecap: square;
        }
    </style>
          <g>
        <polygon class="st0" points="72.2,31.5 17.6,64.3 17.6,93 98.2,46.5"/>
        <polygon class="st0" points="58.3,23.5 17.6,0 17.6,47.9"/>
    </g>
        <line id="Line-3_1_" class="st1" x1="4.5" y1="64" x2="82.8" y2="17"/>
    </svg>
    </div>
    <h1>{{ 'MESSAGES.PLAYBACK_FAILED_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.PLAYBACK_FAILED_SUBTITLE' | translate }}</h2>
    <p>{{ 'MESSAGES.PLAYBACK_FAILED_DETAILS' | translate }}</p>
    <span>{{ 'ERRORS.ERROR_101' | translate }}</span>
  </article>
  <article class="error" *ngIf="isHighTrafficError()">
    <div class="__icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px"
        viewBox="0 0 98 98" style="enable-background:new 0 0 98 98;" xml:space="preserve">
            <style type="text/css">
                .st0 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #39006B;
                }
            </style>
            <g id="Error-States-for-Video-Player-_x28_Final_x29_">
                <g id="Error-Page:-111---Low-bandwidth-Bar-Error" transform="translate(-391.000000, -210.000000)">
                    <g id="Group-5" transform="translate(213.000000, 193.000000)">
                        <g id="timeout-icon" transform="translate(158.000000, 0.000000)">
                        <path class="st0" d="M68.8,17c27,0,48.8,21.9,48.8,49s-21.9,49-48.8,49S20,93.1,20,66S41.9,17,68.8,17z M68.8,21
                            C44,21,24,41.1,24,66s20.1,45,44.9,45s44.9-20.2,44.9-45S93.6,21,68.8,21z M68.8,96.9c1,0,1.9,0.8,2,1.8l0,0.2v4.7
                            c0,1.1-0.9,2-2,2c-1,0-1.9-0.8-2-1.8l0-0.2v-4.7C66.8,97.8,67.7,96.9,68.8,96.9z M45.1,39.4l0.1,0.1l19.3,19.4
                            c1.2-0.8,2.7-1.2,4.2-1.2c1.6,0,3,0.4,4.2,1.2l11.5-11.6c0.8-0.8,2-0.8,2.8,0c0.7,0.7,0.8,1.9,0.1,2.6l-0.1,0.2L75.8,61.7
                            C76.6,63,77,64.4,77,66c0,4.6-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2c0-1.6,0.4-3,1.2-4.3L42.4,42.3c-0.8-0.8-0.8-2,0-2.8
                            C43.2,38.8,44.3,38.8,45.1,39.4z M68.8,61.7c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3
                            C73.1,63.6,71.2,61.7,68.8,61.7z M106.3,64c1.1,0,2,0.9,2,2c0,1-0.8,1.9-1.8,2l-0.2,0h-4.7c-1.1,0-2-0.9-2-2c0-1,0.8-1.9,1.8-2
                            l0.2,0H106.3z M36,64c1.1,0,2,0.9,2,2c0,1-0.8,1.9-1.8,2L36,68h-4.7c-1.1,0-2-0.9-2-2c0-1,0.8-1.9,1.8-2l0.2,0H36z M68.8,26.4
                            c1,0,1.9,0.8,2,1.8l0,0.2v4.7c0,1.1-0.9,2-2,2c-1,0-1.9-0.8-2-1.8l0-0.2v-4.7C66.8,27.3,67.7,26.4,68.8,26.4z"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    <h1>{{ 'MESSAGES.HIGH_TRAFFIC_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.HIGH_TRAFFIC_SUBTITLE' | translate }}</h2>
    <p class="white-space-pre-wrap">{{ 'MESSAGES.HIGH_TRAFFIC_DETAILS' | translate }}</p>
  </article>

  <article class="error __104" *ngIf="isGenerating()">
    <div class="__icon">
      <i class="spinner"></i>
    </div>
    <h1>{{ 'MESSAGES.GENERATING_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.GENERATING_SUBTITLE' | translate }}</h2>
    <p>{{ 'MESSAGES.GENERATING_DETAILS' | translate }}<br></p>
  </article>
  <article class="error _--common" *ngIf="isVideoUnavailableError() || isVideoNotFoundError()">
    <div class="__icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px"
            viewBox="0 0 98.5 93" style="enable-background:new 0 0 98.5 93;" xml:space="preserve">
            <style type="text/css">
                .st0 {
                fill: #39006B;
                }

                .st1 {
                fill: none;
                stroke: #39006B;
                stroke-width: 6;
                stroke-linecap: square;
                }
            </style>
            <g>
                <polygon class="st0" points="72.2,31.5 17.6,64.3 17.6,93 98.2,46.5"/>
                <polygon class="st0" points="58.3,23.5 17.6,0 17.6,47.9"/>
            </g>
            <line id="Line-3_1_" class="st1" x1="4.5" y1="64" x2="82.8" y2="17"/>
        </svg>
    </div>
    <h1>{{ 'MESSAGES.VIDEO_NOT_FOUND_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.VIDEO_NOT_FOUND_SUBTITLE' | translate }}</h2>
    <p>{{ 'MESSAGES.VIDEO_NOT_FOUND_DETAILS' | translate }}</p>
    <ng-container *ngIf="isVideoUnavailableError()">
        <span>{{ 'ERRORS.ERROR_108' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="isVideoNotFoundError()">
        <span>{{ 'ERRORS.ERROR_109' | translate }}</span>
    </ng-container>
  </article>
  <article class="error _--112" *ngIf="isUnsupportedBrowser()">
    <div class="__icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 93 93" style="enable-background:new 0 0 93 93;" xml:space="preserve">
            <style type="text/css">
                .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#39006B;}
            </style>
            <g id="Error-States-for-Video-Player-_x28_Final_x29_">
                <g id="Error-Page:-112---Incompatible-Browser-Error" transform="translate(-394.000000, -239.000000)">
                    <g id="Group-9" transform="translate(205.000000, 239.000000)">
                        <g id="Group-7" transform="translate(189.000000, 0.000000)">
                            <g id="error-icon">
                                <path id="path-1_1_" class="st0" d="M73.1,0.6L46.5,27.3L19.9,0.6c-0.8-0.8-2.2-0.8-3,0L0.6,16.8L0.5,17
                                    c-0.7,0.8-0.6,2.1,0.1,2.8l26.6,26.7L0.6,73.2c-0.8,0.8-0.8,2.2,0,3l16.2,16.2l0.2,0.1c0.8,0.7,2.1,0.6,2.9-0.1l26.6-26.6
                                    l26.6,26.6c0.8,0.8,2.2,0.8,3,0l16.2-16.2l0.1-0.2c0.7-0.8,0.6-2.1-0.1-2.8L65.7,46.5l26.6-26.7c0.8-0.8,0.8-2.2,0-3L76.2,0.6
                                    C75.3-0.2,74-0.2,73.1,0.6z M74.6,5.2l13.2,13.2L61.2,45L61,45.2c-0.7,0.8-0.6,2.1,0.1,2.8l26.6,26.7L74.6,87.8L48,61.2
                                    l-0.2-0.1c-0.8-0.7-2.1-0.6-2.9,0.1L18.4,87.8L5.2,74.7L31.8,48l0.1-0.2c0.7-0.8,0.6-2.1-0.1-2.8L5.2,18.3L18.4,5.2L45,31.8
                                    c0.8,0.8,2.2,0.8,3,0L74.6,5.2z"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </div>
    <h1>{{ 'MESSAGES.INCOMPATIBLE_BROWSER_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.INCOMPATIBLE_BROWSER_SUBTITLE' | translate }}</h2>
    <p class="white-space-pre-wrap">{{ 'MESSAGES.INCOMPATIBLE_BROWSER_DETAILS' | translate }}</p>
    <span>{{ 'ERRORS.ERROR_112' | translate }}</span>
  </article>
  <article class="error _--113" *ngIf="isCreditsUnavailableError()">
    <div class="__icon">
      <i class="pbi-icon-outline pbi-video x6"></i>
    </div>
    <h1>{{ 'MESSAGES.VIDEO_UNAVAILABLE_TITLE' | translate }}</h1>
    <p class="white-space-pre-wrap">{{ 'MESSAGES.VIDEO_UNAVAILABLE_DETAILS' | translate }}</p>
  </article>
  <article class="error _--105" *ngIf="isLowBandwidthError()">
      <div class="__icon">
          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px"
               viewBox="0 0 98 98" style="enable-background:new 0 0 98 98;" xml:space="preserve">
            <style type="text/css">
                .st0 {
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #39006B;
                }
            </style>
              <g id="Error-States-for-Video-Player-_x28_Final_x29_">
                <g id="Error-Page:-111---Low-bandwidth-Bar-Error" transform="translate(-391.000000, -210.000000)">
                    <g id="Group-5" transform="translate(213.000000, 193.000000)">
                        <g id="timeout-icon" transform="translate(158.000000, 0.000000)">
                        <path class="st0" d="M68.8,17c27,0,48.8,21.9,48.8,49s-21.9,49-48.8,49S20,93.1,20,66S41.9,17,68.8,17z M68.8,21
                            C44,21,24,41.1,24,66s20.1,45,44.9,45s44.9-20.2,44.9-45S93.6,21,68.8,21z M68.8,96.9c1,0,1.9,0.8,2,1.8l0,0.2v4.7
                            c0,1.1-0.9,2-2,2c-1,0-1.9-0.8-2-1.8l0-0.2v-4.7C66.8,97.8,67.7,96.9,68.8,96.9z M45.1,39.4l0.1,0.1l19.3,19.4
                            c1.2-0.8,2.7-1.2,4.2-1.2c1.6,0,3,0.4,4.2,1.2l11.5-11.6c0.8-0.8,2-0.8,2.8,0c0.7,0.7,0.8,1.9,0.1,2.6l-0.1,0.2L75.8,61.7
                            C76.6,63,77,64.4,77,66c0,4.6-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2c0-1.6,0.4-3,1.2-4.3L42.4,42.3c-0.8-0.8-0.8-2,0-2.8
                            C43.2,38.8,44.3,38.8,45.1,39.4z M68.8,61.7c-2.4,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3
                            C73.1,63.6,71.2,61.7,68.8,61.7z M106.3,64c1.1,0,2,0.9,2,2c0,1-0.8,1.9-1.8,2l-0.2,0h-4.7c-1.1,0-2-0.9-2-2c0-1,0.8-1.9,1.8-2
                            l0.2,0H106.3z M36,64c1.1,0,2,0.9,2,2c0,1-0.8,1.9-1.8,2L36,68h-4.7c-1.1,0-2-0.9-2-2c0-1,0.8-1.9,1.8-2l0.2,0H36z M68.8,26.4
                            c1,0,1.9,0.8,2,1.8l0,0.2v4.7c0,1.1-0.9,2-2,2c-1,0-1.9-0.8-2-1.8l0-0.2v-4.7C66.8,27.3,67.7,26.4,68.8,26.4z"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    <h1>{{ 'MESSAGES.LOW_BANDWIDTH_TITLE' | translate }}</h1>
    <h2>{{ 'MESSAGES.LOW_BANDWIDTH_SUBTITLE' | translate }}</h2>
    <p>{{ 'MESSAGES.LOW_BANDWIDTH_DETAILS_TITLE' | translate }}</p>
    <p class="white-space-pre-wrap">{{ 'MESSAGES.LOW_BANDWIDTH_DETAILS' | translate }}</p>
    <span>{{ 'ERRORS.ERROR_105' | translate }}</span>
  </article>
</div>
